// extracted by mini-css-extract-plugin
module.exports = {"message":"message--P9EcZ","errorStack":"errorStack--2hjCl"};